<template>
  <div class="laCooperativeCustomers">
    <div class="cooperativeCustomers">合作伙伴</div>
    <div class="mailuoImg">
<!--      树叶脉络 -->
      <img src="../assets/mailuologo/mailuo.png" v-show="!seen" class="context" alt="">
      <img src="../assets/mailuologo/mailuo.png" v-show="!seen1" class="context" alt="">
        <img v-show="seen" src="../assets/mailuologo/11.png" class="mailuoe">
        <img v-show="seen1" src="../assets/mailuologo/6.png" class="mailuoe">
        <img v-show="seen2" src="../assets/mailuologo/15.png" class="mailuoe">
        <img v-show="seen3" src="../assets/mailuologo/16.png" class="mailuoe">
        <img v-show="seen4" src="../assets/mailuologo/12.png" class="mailuoe">
        <img v-show="seen5" src="../assets/mailuologo/17.png" class="mailuoe">
        <img v-show="seen6" src="../assets/mailuologo/13.png" class="mailuoe">
        <img v-show="seen7" src="../assets/mailuologo/19.png" class="mailuoe">
        <img v-show="seen8" src="../assets/mailuologo/18.png" class="mailuoe">
        <img v-show="seen9" src="../assets/mailuologo/14.png" class="mailuoe">
        <img v-show="seen10" src="../assets/mailuologo/1.png" class="mailuoe">
        <img v-show="seen11" src="../assets/mailuologo/2.png" class="mailuoe">
        <img v-show="seen12" src="../assets/mailuologo/8.png" class="mailuoe">
        <img v-show="seen13" src="../assets/mailuologo/7.png" class="mailuoe">
        <img v-show="seen14" src="../assets/mailuologo/4.png" class="mailuoe">
        <img v-show="seen15" src="../assets/mailuologo/10.png" class="mailuoe">
        <img v-show="seen16" src="../assets/mailuologo/9.png" class="mailuoe">
        <img v-show="seen17" src="../assets/mailuologo/5.png" class="mailuoe">
        <img v-show="seen18" src="../assets/mailuologo/3.png" class="mailuoe">
        <img v-show="seen19" src="../assets/mailuologo/20.png" class="mailuoe">
        <img v-show="seen20" src="../assets/mailuologo/21.png"  class="mailuoe">
        <img v-show="seen21" src="../assets/mailuologo/22.png" class="mailuoe">
        <img v-show="seen22" src="../assets/mailuologo/23.png" class="mailuoe">

        <img v-show="seen" class="woshoudohua1 x-container" src="../assets/shakeHands/woshou1.png">
        <img v-show="seen" class="woshoudohua2 comImage" src="../assets/shakeHands/woshou2.png">

        <div v-show="seen1" class='y-container1 x-container'></div>
        <img v-show="seen1" class='x-container2 comImage' src="../assets/shakeHands/woshou2.png">

        <div v-show="seen2" class='y-container1 x-container'></div>
        <img v-show="seen2"  class='x-container2 comImage' src="../assets/shakeHands/woshou2.png">

        <div v-show="seen3" class='y-container1 x-container'></div>
        <img v-show="seen3" class='x-container2 comImage' src="../assets/shakeHands/woshou2.png">

        <div v-show="seen4" class='y-container1 x-container'></div>
        <img v-show="seen4" class='x-container2 comImage' src="../assets/shakeHands/woshou2.png">

        <div v-show="seen5" class='y-container1 x-container'></div>
        <img v-show="seen5" class='x-container2 comImage' src="../assets/shakeHands/woshou2.png">

        <div v-show="seen6" class='y-container1 x-container'></div>
        <img v-show="seen6" class='x-container2 comImage' src="../assets/shakeHands/woshou2.png">

        <div v-show="seen7" class='y-container1 x-container'></div>
        <img v-show="seen7" class='x-container2 comImage' src="../assets/shakeHands/woshou2.png">

        <div v-show="seen8" class='y-container1 x-container'></div>
        <img v-show="seen8" class='x-container2 comImage' src="../assets/shakeHands/woshou2.png">

        <div v-show="seen9" class='y-container1 x-container'></div>
        <img v-show="seen9" class='x-container2 comImage' src="../assets/shakeHands/woshou2.png">

        <div v-show="seen10" class='y-container1 x-container'></div>
        <img v-show="seen10" class='x-container2 comImage' src="../assets/shakeHands/woshou2.png">

        <div v-show="seen11" class='y-container1 x-container'></div>
        <img v-show="seen11" class='x-container2 comImage' src="../assets/shakeHands/woshou2.png">

        <div v-show="seen12" class='y-container1 x-container'></div>
        <img v-show="seen12" class='x-container2 comImage' src="../assets/shakeHands/woshou2.png">

        <div v-show="seen13" class='y-container1 x-container'></div>
        <img v-show="seen13" class='x-container2 comImage' src="../assets/shakeHands/woshou2.png">

        <div v-show="seen14" class='y-container1 x-container'></div>
        <img v-show="seen14" class='x-container2 comImage' src="../assets/shakeHands/woshou2.png">

        <div v-show="seen15" class='y-container1 x-container'></div>
        <img v-show="seen15" class='x-container2 comImage' src="../assets/shakeHands/woshou2.png">

        <div v-show="seen16" class='y-container1 x-container'></div>
        <img v-show="seen16" class='x-container2 comImage' src="../assets/shakeHands/woshou2.png">

        <div v-show="seen17" class='y-container1 x-container'></div>
        <img v-show="seen17" class='x-container2 comImage' src="../assets/shakeHands/woshou2.png">

        <div v-show="seen18" class='y-container1 x-container'></div>
        <img v-show="seen18" class='x-container2 comImage' src="../assets/shakeHands/woshou2.png">

        <div v-show="seen19" class='y-container1 x-container'></div>
        <img v-show="seen19" class='x-container2 comImage' src="../assets/shakeHands/woshou2.png">

        <div v-show="seen20" class='y-container1 x-container'></div>
        <img v-show="seen20" class='x-container2 comImage' src="../assets/shakeHands/woshou2.png">

        <div v-show="seen21" class='y-container1 x-container'></div>
        <img v-show="seen21" class='x-container2 comImage' src="../assets/shakeHands/woshou2.png">

        <div v-show="seen22" class='y-container1 x-container'></div>
        <img v-show="seen22" class='x-container2 comImage' src="../assets/shakeHands/woshou2.png">

      <div class="mailuo-box box">
        <img class="images" @mouseenter="enter" @mouseleave="leave" src="../assets/hezuologo/huawei.png" />
          <img v-show="seen" class="woshoudohua x-container" src="../assets/shakeHands/woshou.png">
      </div>
      <div class="mailuo-box1 box">
        <img class="images" @mouseenter="enter1" @mouseleave="leave1" src="../assets/hezuologo/xiaomi.png" />
          <div v-show="seen1" class='x-container'>
              <div class='y-container x-container'></div>
          </div>
      </div>
      <div class="mailuo-box2 box">
        <img class="images" @mouseenter="enter2" @mouseleave="leave2" src="../assets/hezuologo/kuaishou.png" />
          <div v-show="seen2" class='xcontainer3 x-container'>
              <div class='y-container4 x-container'></div>
          </div>
      </div>
      <div class="mailuo-box3 box">
        <img class="images" @mouseenter="enter3" @mouseleave="leave3" src="../assets/hezuologo/kugou.png" />
          <div v-show="seen3" class='xcontainer5 x-container'>
              <div class='y-container6 x-container'></div>
          </div>
      </div>
      <div class="mailuo-box4 box">
        <img class="images" @mouseenter="enter4" @mouseleave="leave4" src="../assets/hezuologo/oppo.webp" />
          <div v-show="seen4" class='xcontainer6 x-container'>
              <div class='ycontainer6 x-container'></div>
          </div>
      </div>
      <div class="mailuo-box5 box">
        <img class="images" @mouseenter="enter5" @mouseleave="leave5" src="../assets/hezuologo/vivo.webp" />
          <div v-show="seen5" class='xy1 x-container'>
              <div class='xy2 x-container'></div>
          </div>
      </div>
      <div class="mailuo-box6 box">
        <img class="images" @mouseenter="enter6" @mouseleave="leave6" src="../assets/hezuologo/toutiao.png" />
          <div v-show="seen6" class='xy5 x-container'>
              <div class='xy6 x-container'></div>
          </div>
      </div>
      <div class="mailuo-box7 box">
        <img class="images" @mouseenter="enter7" @mouseleave="leave7" src="../assets/hezuologo/aiqiyi.jpg" />
          <div v-show="seen7" class='xy9 x-container'>
              <div class='xy10 x-container'></div>
          </div>
      </div>
      <div class="mailuo-box8 box">
        <img class="images" @mouseenter="enter8" @mouseleave="leave8" src="../assets/hezuologo/meizu.webp" />
          <div v-show="seen8" class='xy13 x-container'>
              <div class='xy14 x-container'></div>
          </div>
      </div>
      <div class="mailuo-box9 box">
        <img class="images" @mouseenter="enter9" @mouseleave="leave9" src="../assets/hezuologo/guandiantong.png" />
          <div v-show="seen9" class='xy17 x-container'>
              <div class='xy18 x-container'></div>
          </div>
      </div>
      <div class="mailuo-box10 box">
        <img class="images" @mouseenter="enter10" @mouseleave="leave10" src="../assets/hezuologo/doov.webp" />
          <div v-show="seen10" class='xy21 x-container'>
              <div class='xy22 x-container'></div>
          </div>
      </div>
      <div class="mailuo-box11 box">
        <img class="images" @mouseenter="enter11" @mouseleave="leave11" src="../assets/hezuologo/onoa.webp" />
          <div v-show="seen11" class='xy25 x-container'>
              <div class='xy26 x-container'></div>
          </div>
      </div>
      <div class="mailuo-box12 box">
        <img class="images" @mouseenter="enter12" @mouseleave="leave12" src="../assets/hezuologo/tian.png" />
          <div v-show="seen12" class='xy29 x-container'>
              <div class='xy30 x-container'></div>
          </div>
      </div>
      <div class="mailuo-box13 box">
        <img class="images" @mouseenter="enter13" @mouseleave="leave13" src="../assets/hezuologo/tianqi.png" />
          <div v-show="seen13" class='xy33 x-container'>
              <div class='xy34 x-container'></div>
          </div>
      </div>
      <div class="mailuo-box14 box">
        <img class="images" @mouseenter="enter14" @mouseleave="leave14" src="../assets/hezuologo/win.png" />
          <div v-show="seen14" class='xy37 x-container'>
              <div class='xy38 x-container'></div>
          </div>
      </div>
      <div class="mailuo-box15 box">
        <img class="images" @mouseenter="enter15" @mouseleave="leave15" src="../assets/hezuologo/taqu.png" />
          <div v-show="seen15" class='xy41 x-container'>
              <div class='xy42 x-container'></div>
          </div>
      </div>
      <div class="mailuo-box16 box">
        <img class="images" @mouseenter="enter16" @mouseleave="leave16" src="../assets/hezuologo/yi.png" />
          <div v-show="seen16" class='xy45 x-container'>
              <div class='xy46 x-container'></div>
          </div>
      </div>
      <div class="mailuo-box17 box">
        <img class="images" @mouseenter="enter17" @mouseleave="leave17" src="../assets/hezuologo/dashao.png" />
          <div v-show="seen17" class='xy49 x-container'>
              <div class='xy50 x-container'></div>
          </div>
      </div>
      <div class="mailuo-box18 box">
        <img class="images" @mouseenter="enter18" @mouseleave="leave18" src="../assets/hezuologo/yundo.png" />
          <div v-show="seen18" class='xy53 x-container'>
              <div class='xy54 x-container'></div>
          </div>
      </div>
      <div class="mailuo-box19 box">
        <img class="images" @mouseenter="enter19" @mouseleave="leave19" src="../assets/hezuologo/wanq.png" />
          <div v-show="seen19" class='xy57 x-container'>
              <div class='xy58 x-container'></div>
          </div>
      </div>
      <div class="mailuo-box20 box">
        <img class="images" @mouseenter="enter20" @mouseleave="leave20" src="../assets/hezuologo/tianyi.png" />
          <div v-show="seen20" class='xy61 x-container'>
              <div class='xy62 x-container'></div>
          </div>
      </div>
      <div class="mailuo-box21 box">
        <img class="images" @mouseenter="enter21" @mouseleave="leave21" src="../assets/hezuologo/ryi.png" />
          <div v-show="seen21" class='xy65 x-container'>
              <div class='xy66 x-container'></div>
          </div>
      </div>
      <div class="mailuo-box22 box">
        <img class="images" @mouseenter="enter22" @mouseleave="leave22" src="../assets/hezuologo/yaoshi.png" />
          <div v-show="seen22" class='xy69 x-container'>
              <div class='xy70 x-container'></div>
          </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "LaCooperativeCustomers",
    data(){
      return{
          seen:false,
          seen1:false,
          seen2:false,
          seen3:false,
          seen4:false,
          seen5:false,
          seen6:false,
          seen7:false,
          seen8:false,
          seen9:false,
          seen10:false,
          seen11:false,
          seen12:false,
          seen13:false,
          seen14:false,
          seen15:false,
          seen16:false,
          seen17:false,
          seen18:false,
          seen19:false,
          seen20:false,
          seen21:false,
          seen22:false,
      }
    },
    methods:{
        enter(){
            this.seen = true;
        },
        leave() {
            this.seen = false
        },
        enter1(){
          this.seen1 = true;
        },
        leave1() {
          this.seen1 = false
        },
        enter2(){
          this.seen2 = true;
        },
        leave2() {
          this.seen2 = false
        },
        enter3(){
          this.seen3 = true;
        },
        leave3() {
          this.seen3 = false
        },
        enter4(){
          this.seen4 = true;
        },
        leave4() {
          this.seen4 = false
        },
      enter5(){
        this.seen5 = true;
      },
      leave5() {
        this.seen5 = false
      },
      enter6(){
        this.seen6 = true;
      },
      leave6() {
        this.seen6 = false
      },
      enter7(){
        this.seen7 = true;
      },
      leave7() {
        this.seen7 = false
      },
      enter8(){
        this.seen8 = true;
      },
      leave8() {
        this.seen8 = false
      },
      enter9(){
        this.seen9 = true;
      },
      leave9() {
        this.seen9 = false
      },
      enter10(){
        this.seen10 = true;
      },
      leave10() {
        this.seen10 = false
      },
      enter11(){
        this.seen11 = true;
      },
      leave11() {
        this.seen11 = false
      },
      enter12(){
        this.seen12 = true;
      },
      leave12() {
        this.seen12 = false
      },
      enter13(){
        this.seen13 = true;
      },
      leave13() {
        this.seen13 = false
      },
      enter14(){
        this.seen14 = true;
      },
      leave14() {
        this.seen14 = false
      },
      enter15(){
        this.seen15 = true;
      },
      leave15() {
        this.seen15 = false
      },
      enter16(){
        this.seen16 = true;
      },
      leave16() {
        this.seen16 = false
      },
      enter17(){
        this.seen17 = true;
      },
      leave17() {
        this.seen17 = false
      },
      enter18(){
        this.seen18 = true;
      },
      leave18() {
        this.seen18 = false
      },
      enter19(){
        this.seen19 = true;
      },
      leave19() {
        this.seen19 = false
      },
      enter20(){
        this.seen20 = true;
      },
      leave20() {
        this.seen20 = false
      },
      enter21(){
        this.seen21 = true;
      },
      leave21() {
        this.seen21 = false
      },
      enter22(){
        this.seen22 = true;
      },
      leave22() {
        this.seen22 = false
      },
    }
}
</script>

<style scoped>
    .laCooperativeCustomers {
        width: 1800px;
        margin: auto;
        height: 1200px;
        text-align: center;
    }
    .cooperativeCustomers {
        font-size: 2rem;
        height: 80px;
        color: #212529;
    }
    /* 树叶脉络框 */
    .mailuoImg {
        z-index: 1;
        height: 100%;
        width: 100%;
        position: relative;
    }
    .context {
        height: 100%;
        z-index: -10;
        width: 100%;
        position: absolute;
        left: 0%;
    }
    .mailuo-box {
        position: absolute;
        top: 117px;
        left: 50%;
    }
    .box{
        position: relative;
        width: 120px;
        height: 120px;
        background: url("../assets/hezuologo/yuanxing.png") no-repeat center/100% auto;
    }
    .images{
        width: 80px;
        height: 80px;
        margin-top: 20px;
        border-radius: 30%;
    }
    .mailuoe{
        z-index: -9;
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
    }
    .comImage{
        width: 100px;
        height: 100px;
        animation: imgBox 2.5s linear 1;
    }
    /*第一次握手*/
    .mailuo-box .woshoudohua{
        position: absolute;
        top: 80%;
        left: 20%;
        animation: woshoudohua 1s linear 1 forwards;
    }
    /*第一次握手*/
    @-webkit-keyframes woshoudohua{
        0%{ -webkit-transform:translateY(0); opacity:0;}
        99%{ -webkit-transform:translateY(1200%); opacity:1;}
        100%{ -webkit-transform:translateY(1200%); opacity:0;}
    }
    /*第一次握手*/
    .mailuoImg .woshoudohua1{
        position: absolute;
        left: 50%;
        top: 100%;
        animation: woshoudohua1 1s linear 1 forwards;
    }
    /*第一次握手*/
    @-webkit-keyframes woshoudohua1{
        0%{ -webkit-transform:translateY(0); opacity:0;}
        99%{ -webkit-transform:translateY(-500%); opacity:1;}
        100%{ -webkit-transform:translateY(-500%); opacity:0;}
    }
    .mailuoImg .woshoudohua2{
        position: absolute;
        left: 49%;
        top: 70%;
        animation: woshoudohua2 1s linear 1;
    }
    @-webkit-keyframes woshoudohua2{
        0%{ -webkit-transform:translateY(0); opacity:0;}
        20%{ -webkit-transform:translateY(0); opacity:0;}
        50%{ -webkit-transform:translateY(0); opacity:0;}
        70%{ -webkit-transform:translateY(0); opacity:0;}
        90%{ -webkit-transform:translateY(0); opacity:0;}
        100%{ -webkit-transform:translateY(0); opacity:1;}
    }
    /*第一次握手结束*/
    .mailuo-box1 {
        position: absolute;
        top: 375px;
        left: 26%;
    }
    /*第二次握手 开始*/
    .x-container{
        width: 50px;
        height: 50px;
    }
    .y-container{
        position: absolute;
        z-index: -1;
        top: 40%;
        left: 50%;
        background: url("../assets/shakeHands/woshou.png") no-repeat center/100% auto;
        animation: yMove 2s cubic-bezier(1,1,0,0);
    }
    /*第二次握手*/
    @keyframes yMove {
        0% {
        }
        100% {
            transform: translate(400px,450px);
        }
    }
    /*第二次握手*/
    .y-container1{
        position: absolute;
        top: 88%;
        left: 50%;
        background: url("../assets/shakeHands/woshou1.png") no-repeat center/100% auto;
        animation: y-container1 2s linear 1;
    }
    @-webkit-keyframes y-container1{
        0%{ -webkit-transform:translateY(0); opacity:0;}
        100%{ -webkit-transform:translateY(-300%); opacity:1;}
    }
    .x-container2{
        position: absolute;
        top: 70%;
        left: 49%;
        animation: x-container2 2.5s linear 1;
    }
    @-webkit-keyframes x-container2{
        0%{ -webkit-transform:translateY(0); opacity:0;}
        20%{ -webkit-transform:translateY(0); opacity:0;}
        50%{ -webkit-transform:translateY(0); opacity:0;}
        70%{ -webkit-transform:translateY(0); opacity:0;}
        100%{ -webkit-transform:translateY(0); opacity:1;}
    }
    /*第二次握手 结束*/
    .mailuo-box2 {
        position: absolute;
        top: 347px;
        left: 76%;
    }
    /*第三次握手 开始*/
    .xcontainer3{
        z-index: -1;
        position: absolute;
        top: 25%;
        left: 30%;
    }
    .y-container4{
        background: url("../assets/shakeHands/woshou.png") no-repeat center/100% auto;
        animation: xyMove 2s cubic-bezier(1,1,0,0);
    }
    /*第三次握手*/
    @keyframes xyMove {
        0% {
        }
        100% {
            transform: translate(-480px,480px);
        }
    }
    /*第三次握手 结束*/
    .mailuo-box3 {
        position: absolute;
        top: 253px;
        left: 68%;
    }
    /*第四次握手 开始*/
    .xcontainer5{
        z-index: -1;
        position: absolute;
        top: 25%;
        left: 30%;
        animation: xMove2 2s linear;
    }
    .y-container6{
        background: url("../assets/shakeHands/woshou.png") no-repeat center/100% auto;
        animation: xyMove1 2s cubic-bezier(1,1,0,0);
    }
    @keyframes xyMove1 {
        0% {
        }
        100% {
            transform: translate(-340px,580px);
        }
    }
    /*第四次握手 结束*/
    .mailuo-box4 {
        position: absolute;
        top: 235px;
        left: 45%;
    }
    /*第四次握手 开始*/
    .xcontainer6{
        z-index: -1;
        position: absolute;
        top: 25%;
        left: 30%;
        animation: xMove2 2s linear;
    }
    .ycontainer6{
        background: url("../assets/shakeHands/woshou.png") no-repeat center/100% auto;
        animation: xyMove2 2s cubic-bezier(1,1,0,0);
    }
    @keyframes xyMove2 {
        0% {
        }
        100% {
            transform: translate(70px,580px);
        }
    }
    /*第四次握手 结束*/
    .mailuo-box5 {
        position: absolute;
        top: 464px;
        left: 75%;
    }
    /*第五次握手 开始*/
    .xy1{
        z-index: -1;
        position: absolute;
        top: 25%;
        left: 30%;
        animation: xMove3 2s linear;
    }
    .xy2{
        background: url("../assets/shakeHands/woshou.png") no-repeat center/100% auto;
        animation: xyMove3 2s cubic-bezier(1,1,0,0);
    }
    @keyframes xyMove3 {
        0% {
        }
        100% {
            transform: translate(-480px,380px);
        }
    }
    /*第五次握手 结束*/
    .mailuo-box6 {
        position: absolute;
        top: 337px;
        left: 54%;
    }
    /*第六次握手 开始*/
    .xy5{
        z-index: -1;
        position: absolute;
        top: 25%;
        left: 30%;
        animation: xMove4 2s linear;
    }
    .xy6{
        background: url("../assets/shakeHands/woshou.png") no-repeat center/100% auto;
        animation: xyMove4 2s cubic-bezier(1,1,0,0);
    }
    @keyframes xyMove4 {
        0% {
        }
        100% {
            transform: translate(-100px,480px);
        }
    }
    /*第六次握手 结束*/
    .mailuo-box7 {
        position: absolute;
        top: 578px;
        left: 71%;
    }
    /*第七次握手 开始*/
    .xy9{
        z-index: -1;
        position: absolute;
        top: 25%;
        left: 30%;
        animation: xMove5 2s linear;
    }
    .xy10{
        background: url("../assets/shakeHands/woshou.png") no-repeat center/100% auto;
        animation: xyMove5 2s cubic-bezier(1,1,0,0);
    }
    @keyframes xyMove5 {
        0% {
        }
        100% {
            transform: translate(-400px,260px);
        }
    }
    /*第七次握手 结束*/
    .mailuo-box8 {
        position: absolute;
        top: 396px;
        left: 60%;
    }
    /*第八次握手 开始*/
    .xy13{
        z-index: -1;
        position: absolute;
        top: 25%;
        left: 30%;
        animation: xMove6 2s linear;
    }
    .xy14{
        background: url("../assets/shakeHands/woshou.png") no-repeat center/100% auto;
        animation: xyMove6 2s cubic-bezier(1,1,0,0);
    }
    @keyframes xyMove6 {
        0% {
        }
        100% {
            transform: translate(-190px,400px);
        }
    }
    /*第八次握手 结束*/
    .mailuo-box9 {
        position: absolute;
        top: 401px;
        left: 43%;
    }
    /*第九次握手 开始*/
    .xy17{
        z-index: -1;
        position: absolute;
        top: 25%;
        left: 30%;
        animation: xMove6 2s linear;
    }
    .xy18{
        background: url("../assets/shakeHands/woshou.png") no-repeat center/100% auto;
        animation: xyMove7 2s cubic-bezier(1,1,0,0);
    }
    @keyframes xyMove7 {
        0% {
        }
        100% {
            transform: translate(90px,420px);
        }
    }
    /*第九次握手 结束*/
    .mailuo-box10 {
        position: absolute;
        top: 845px;
        left: 21%;
    }
    /*第十次握手 开始*/
    .xy21{
        z-index: -1;
        position: absolute;
        top: 25%;
        left: 30%;
        animation: xMove6 2s linear;
    }
    .xy22{
        background: url("../assets/shakeHands/woshou.png") no-repeat center/100% auto;
        animation: xyMove8 2s cubic-bezier(1,1,0,0);
    }
    @keyframes xyMove8 {
        0% {
        }
        100% {
            transform: translate(490px,10px);
        }
    }
    /*第十次握手 结束*/
    .mailuo-box11 {
        position: absolute;
        top: 910px;
        left: 27%;
    }
    /*第十一次握手 开始*/
    .xy25{
        z-index: -1;
        position: absolute;
        top: 25%;
        left: 30%;
        animation: xMove6 2s linear;
    }
    .xy26{
        background: url("../assets/shakeHands/woshou.png") no-repeat center/100% auto;
        animation: xyMove9 2s cubic-bezier(1,1,0,0);
    }
    @keyframes xyMove9 {
        0% {
        }
        100% {
            transform: translate(370px,-50px);
        }
    }
    /*第十一次握手 结束*/
    .mailuo-box12 {
        position: absolute;
        top: 350px;
        left: 34%;
    }
    /*第十二次握手 开始*/
    .xy29{
        z-index: -1;
        position: absolute;
        top: 25%;
        left: 30%;
        animation: xMove6 2s linear;
    }
    .xy30{
        background: url("../assets/shakeHands/woshou.png") no-repeat center/100% auto;
        animation: xyMove10 2s cubic-bezier(1,1,0,0);
    }
    @keyframes xyMove10 {
        0% {
        }
        100% {
            transform: translate(270px,470px);
        }
    }
    /*第十二次握手 结束*/
    .mailuo-box13 {
        position: absolute;
        top: 510px;
        left: 26%;
    }
    /*第十三次握手 开始*/
    .xy33{
        z-index: -1;
        position: absolute;
        top: 25%;
        left: 30%;
        animation: xMove6 2s linear;
    }
    .xy34{
        background: url("../assets/shakeHands/woshou.png") no-repeat center/100% auto;
        animation: xyMove11 2s cubic-bezier(1,1,0,0);
    }
    @keyframes xyMove11 {
        0% {
        }
        100% {
            transform: translate(410px,310px);
        }
    }
    /*第十三次握手 结束*/
    .mailuo-box14 {
        position: absolute;
        top: 750px;
        left: 26%;
    }
    /*第十四次握手 开始*/
    .xy37{
        z-index: -1;
        position: absolute;
        top: 25%;
        left: 30%;
        animation: xMove6 2s linear;
    }
    .xy38{
        background: url("../assets/shakeHands/woshou.png") no-repeat center/100% auto;
        animation: xyMove12 2s cubic-bezier(1,1,0,0);
    }
    @keyframes xyMove12 {
        0% {
        }
        100% {
            transform: translate(400px,100px);
        }
    }
    /*第十四次握手 结束*/
    .mailuo-box15 {
        position: absolute;
        top: 620px;
        left: 32%;
    }
    /*第十五次握手 开始*/
    .xy41{
        z-index: -1;
        position: absolute;
        top: 25%;
        left: 30%;
        animation: xMove6 2s linear;
    }
    .xy42{
        background: url("../assets/shakeHands/woshou.png") no-repeat center/100% auto;
        animation: xyMove13 2s cubic-bezier(1,1,0,0);
    }
    @keyframes xyMove13 {
        0% {
        }
        100% {
            transform: translate(290px,190px);
        }
    }
    /*第十五次握手 结束*/
    .mailuo-box16 {
        position: absolute;
        top: 503px;
        left: 42%;
    }
    /*第十六次握手 开始*/
    .xy45{
        z-index: -1;
        position: absolute;
        top: 25%;
        left: 30%;
        animation: xMove6 2s linear;
    }
    .xy46{
        background: url("../assets/shakeHands/woshou.png") no-repeat center/100% auto;
        animation: xyMove14 2s cubic-bezier(1,1,0,0);
    }
    @keyframes xyMove14 {
        0% {
        }
        100% {
            transform: translate(100px,290px);
        }
    }
    /*第十六次握手 结束*/
    .mailuo-box17 {
        position: absolute;
        top: 730px;
        left: 35%;
    }
    /*第十七握手 开始*/
    .xy49{
        z-index: -1;
        position: absolute;
        top: 25%;
        left: 30%;
        animation: xMove6 2s linear;
    }
    .xy50{
        background: url("../assets/shakeHands/woshou.png") no-repeat center/100% auto;
        animation: xyMove15 2s cubic-bezier(1,1,0,0);
    }
    @keyframes xyMove15 {
        0% {
        }
        100% {
            transform: translate(220px,100px);
        }
    }
    /*第十七次握手 结束*/
    .mailuo-box18 {
        position: absolute;
        top: 920px;
        left: 35%;
    }
    /*第十八次握手 开始*/
    .xy53{
        z-index: -1;
        position: absolute;
        top: 25%;
        left: 30%;
        animation: xMove6 2s linear;
    }
    .xy54{
        background: url("../assets/shakeHands/woshou.png") no-repeat center/100% auto;
        animation: xyMove16 2s cubic-bezier(1,1,0,0);
    }
    @keyframes xyMove16 {
        0% {
        }
        100% {
            transform: translate(220px,-60px);
        }
    }
    /*第十八次握手 结束*/
    .mailuo-box19 {
        position: absolute;
        top: 820px;
        left: 74%;
    }
    /*第十九次握手 开始*/
    .xy57{
        z-index: -1;
        position: absolute;
        top: 25%;
        left: 30%;
        animation: xMove6 2s linear;
    }
    .xy58{
        background: url("../assets/shakeHands/woshou.png") no-repeat center/100% auto;
        animation: xyMove17 2s cubic-bezier(1,1,0,0);
    }
    @keyframes xyMove17 {
        0% {
        }
        100% {
            transform: translate(-460px,20px);
        }
    }
    /*第十九次握手 结束*/
    .mailuo-box20 {
        position: absolute;
        top: 752px;
        left: 70%;
    }
    /*第二十次握手 开始*/
    .xy61{
        z-index: -1;
        position: absolute;
        top: 25%;
        left: 30%;
        animation: xMove6 2s linear;
    }
    .xy62{
        background: url("../assets/shakeHands/woshou.png") no-repeat center/100% auto;
        animation: xyMove18 2s cubic-bezier(1,1,0,0);
    }
    @keyframes xyMove18 {
        0% {
        }
        100% {
            transform: translate(-400px,80px);
        }
    }
    /*第二十次握手 结束*/
    .mailuo-box21 {
        position: absolute;
        top: 952px;
        left: 68%;
    }
    /*第二十次握手 开始*/
    .xy65{
        z-index: -1;
        position: absolute;
        top: 25%;
        left: 30%;
        animation: xMove6 2s linear;
    }
    .xy66{
        background: url("../assets/shakeHands/woshou.png") no-repeat center/100% auto;
        animation: xyMove19 2s cubic-bezier(1,1,0,0);
    }
    @keyframes xyMove19 {
        0% {
        }
        100% {
            transform: translate(-350px,-100px);
        }
    }
    /*第二十次握手 结束*/
    .mailuo-box22 {
        position: absolute;
        top: 702px;
        left: 61%;
    }
    /*第二十次握手 开始*/
    .xy69{
        z-index: -1;
        position: absolute;
        top: 25%;
        left: 30%;
        animation: xMove6 2s linear;
    }
    .xy70{
        background: url("../assets/shakeHands/woshou.png") no-repeat center/100% auto;
        animation: xyMove20 2s cubic-bezier(1,1,0,0);
    }
    @keyframes xyMove20 {
        0% {
        }
        100% {
            transform: translate(-240px,140px);
        }
    }
    /*第二十次握手 结束*/
</style>